export const MAX_LOGO_WIDTH = "200px";
export const MAX_LOGO_HEIGHT = "90px"